import React from "react";
import usePageName from "./usePageName";

const useActiveSidebar = () => {
  const { pathname } = usePageName();
  let isGameTab = false;
  let isReportTab = false;
  let isRoleTab = false;
  let isGlobalTab = false;
  let isConfigTab = false;

  // route name
  if (pathname.startsWith("/eventmaster")) isGameTab = true;
  if (pathname.startsWith("/reports")) isReportTab = true;
  if (pathname.startsWith("/rolemanager")) isRoleTab = true;
  if (pathname.startsWith("/globalsettings")) isGlobalTab = true;
  if (pathname.startsWith("/config")) isConfigTab = true;

  return { isGameTab, isReportTab, isRoleTab, isGlobalTab, isConfigTab };
};

export default useActiveSidebar;
